module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_heading-ashinagasan2501-pc-c4e18f5b1344c5af9f42171c3a3a54a6.png";